module.exports = __webpack_public_path__ + "img/answer-bg.svg";